/**
 * Registers the offline service worker (public/sw.js) — production only.
 * In dev it would intercept Vite's module requests and serve stale assets, so
 * we skip it; the localStorage plan cache still covers reload/outage locally.
 */
export function registerPlayerSW(): void {
  if (import.meta.env.PROD && "serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }
}
